import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'kp-done-animation',
  templateUrl: './done-animation.component.html',
  styleUrls: ['./done-animation.component.scss'],
})
export class DoneAnimationComponent implements OnInit {
  @Input() set doneMessage(value: string) {
    this.message = value || 'Done!';
  }
  @Output() animationStateChange: EventEmitter<boolean> = new EventEmitter();

  canvasHeight = 900;
  canvasWidth = 750;
  message = 'Done!';
  playAnimation = true;

  @HostBinding('class.use-alternate')
  useAlternate = false;

  ngOnInit() {
    // use generic alternate if no WASM support or if no animation provided
    this.useAlternate = typeof WebAssembly !== 'object';

    if (this.useAlternate) {
      setTimeout(() => this.playChange(), 1400);
    }
  }

  playChange() {
    setTimeout(() => this.animationStateChange.emit(false), 1500);
  }
}
